import React from 'react';
import clsx from 'clsx';

import styles from './Navbar.module.scss';
import { StandardProps } from '../../types/common';

export const NavbarCenter = ({
  children,
  className,
  style,
  testid = 'navbar-center',
  ...props
}: StandardProps): JSX.Element => {
  return (
    <>
      <div
        className={clsx(styles['hds-navbar__center'], className)}
        style={style}
        data-testid={testid}
        {...props}
      >
        {children}
      </div>
    </>
  );
};
